import { useEffect, useRef, useState, useCallback } from "react";
import { API } from "@/lib/api";

const WS_URL = API.replace(/^http/, "ws") + "/ws";

// Subscribe to the live snapshot broadcast from the backend.
export function useLiveState() {
  const [snapshot, setSnapshot] = useState(null);
  const [connected, setConnected] = useState(false);
  const wsRef = useRef(null);
  const retryRef = useRef(null);

  const connect = useCallback(() => {
    const ws = new WebSocket(WS_URL);
    wsRef.current = ws;
    ws.onopen = () => setConnected(true);
    ws.onmessage = (evt) => {
      try {
        const data = JSON.parse(evt.data);
        if (data.type === "snapshot") setSnapshot(data);
      } catch (e) {}
    };
    ws.onclose = () => {
      setConnected(false);
      retryRef.current = setTimeout(connect, 1500);
    };
    ws.onerror = () => ws.close();
  }, []);

  useEffect(() => {
    connect();
    return () => {
      if (retryRef.current) clearTimeout(retryRef.current);
      if (wsRef.current) {
        wsRef.current.onclose = null;
        wsRef.current.close();
      }
    };
  }, [connect]);

  return { snapshot, connected };
}
